import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { RegionalState } from "./regional-setting.state";

export const RegionalActions = createActionGroup({
  source: 'Navbar Regional Setting',
  events: {
    'Load Data': props<RegionalState>(),
    'Update Data': props<RegionalState>(),
    'Change country': props<({country: string})>(),
    'Change language': props<({language: string})>(),
    'Change currency': props<({currency: string})>(),
    'Initialize': emptyProps()
  }
})